<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Monitor de Servicios</h4>
            <div class="small text-muted">Visualiza todos los servicios a clientes</div>
          </b-col>
          
          <b-col sm="5">            
            <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                <i class="fa fa-filter"></i> Mostrar Filtros
              </b-button>
            </b-col>
            <b-col sm="12" class="d-none d-md-block" v-else>
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                <i class="fa fa-window-close"></i>
              </b-button>
            </b-col>
          </b-col>                    
        </b-row>
      </b-card>

      <b-tabs class="mt-3">
        <b-tab title="Servicios" active>

          <b-row class="mb-2" v-if="moduleSalesActive && onlyOneCustomerFilter">
              <b-col sm="12">
                <b-dropdown right text="Acciones" variant="primary" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Acciones sobre servicios">

                  <b-dropdown-header v-if="moduleSalesActive && onlyOneCustomerFilter">
                    Operaciones
                  </b-dropdown-header>                            
                  <b-dropdown-item @click="generateInvoiceAll()" v-if="moduleSalesActive && onlyOneCustomerFilter">
                    <b-icon icon="file-earmark-ruled" title="Facturar todos los servicios"></b-icon> Facturar
                  </b-dropdown-item>                

                  <b-dropdown-header v-if="onlyOneCustomerFilter">
                    Notificaciones
                  </b-dropdown-header>                                  
                  <b-dropdown-item @click="generateTextNotificationEmailAll()" v-if="onlyOneCustomerFilter">
                    <b-icon icon="envelope"></b-icon> Notificación Email
                  </b-dropdown-item>                                                  
                  <b-dropdown-item @click="generateTextNotificationWhatsappAll()" v-if="onlyOneCustomerFilter">
                    <b-icon icon="whatsapp"></b-icon> Notificación Whatsapp
                  </b-dropdown-item>                                                    
                </b-dropdown>
              </b-col>
            </b-row>

          <b-card header-tag="header" footer-tag="footer">
            <b-row v-if="table.mostrarFiltros">
              <b-col sm="4">
                <v-select :options="arr.filter.customers" v-model="filter.customers" placeholder="Clientes" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>               
              <b-col sm="4">
                <v-select :options="arr.filter.services" v-model="filter.services" placeholder="Servicios" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>            
              <b-col sm="2">
                <v-select :options="arr.filter.status" v-model="filter.status" placeholder="Estado" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>              
              <b-col sm="2">
                <b-button variant="outline-dark float-right" @click="filterServicesCustomersDetails()">
                  <b-icon icon="filter" class="mr-1" style="font-size:15px;"></b-icon> Filtrar
                </b-button>
              </b-col>                         
            </b-row>

            <b-row>
              <b-col>

                <b-table class="mt-2 mb-0 table-displat-services-custom"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :current-page="table.currentPage"
                        :per-page="table.perPage" 
                        :busy="table.isBusy"                       
                        :items="table.items"
                        :fields="table.fields"
                        v-if="table.items || table.isBusy"
                        foot>  

                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"                    
                        :key="field.key"
                        :style="{ width: field.width }"
                      >
                    </template> 

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(customers)="data">                  
                      <div v-if="data.item.service_customer.customer_id">             
                        <b-avatar :src="data.item.service_customer.customer.image"
                                  v-if="data.item.service_customer.customer.image">
                        </b-avatar>
                        <b-avatar v-else 
                                  icon="building"                                            
                                  variant="dark">
                        </b-avatar>     
                        &nbsp;<b>{{data.item.service_customer.customer.name}}</b>      
                        <b-icon icon="circle-fill" v-if="!data.item.service_customer.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
                      </div>
                    </template>                

                    <template v-slot:cell(renewal)="data">                                                                        
                      <span v-if="data.item.service.mode=='days' || data.item.service.mode=='months' || data.item.service.mode=='years'">
                        <b-avatar v-if="data.item.service.automatic_renewal" 
                                  variant="secondary" 
                                  size="md"
                                  :title="'Renovación Automática cada ' + data.item.service.renewal + ' ' + getModeName(data.item.service.mode)"
                                  class="align-baseline display-services-legend-renewal"
                                  :text="data.item.service.renewal.toString()"
                                  badge-variant="success"
                                  badge="A">
                        </b-avatar>
                        <b-avatar v-else 
                                  variant="secondary" 
                                  size="md"
                                  :title="'Renovación Manual cada ' + data.item.service.renewal + ' ' + getModeName(data.item.service.mode)"
                                  class="align-baseline display-services-legend-renewal"
                                  :text="data.item.service.renewal.toString()"
                                  badge-variant="danger"
                                  badge="M">
                        </b-avatar>                     
                      </span>
                    </template>

                    <template v-slot:cell(services)="data">     
                      <div v-if="data.item.service">
                        <strong>{{data.item.service.name}}</strong><br>
                        {{data.item.service_customer.name}}            
                      </div>          
                    </template>        

                    <template v-slot:cell(observations)="data">                      
                      <span v-if="data.item.observations">                                                    
                        <b-badge variant="dark" :id="'popover-observations-' + data.item.id" class="popover-observations">
                          <b-icon icon="card-heading" style="width: 15px; height: 15px; cursor:pointer;" variant="info"></b-icon> 
                        </b-badge>
                        <b-popover :target="'popover-observations-' + data.item.id" variant="default" triggers="hover">                            
                          <div v-html="previewPopoverObservations(data.item)"></div>
                        </b-popover>                                                    
                      </span>                          
                    </template>

                    <template v-slot:cell(date_init)="data">  
                      {{moment(data.item.date_init).format('DD/MM/YYYY')}}
                    </template>  

                    <template v-slot:cell(date_end)="data">  
                      <div v-if="data.item.date_end">
                        {{moment(data.item.date_end).format('DD/MM/YYYY')}}
                      </div>
                    </template>  

                    <template v-slot:cell(list)="data">     
                      <span v-if="data.item.price_list">
                        {{data.item.price_list.reference}}
                      </span>
                    </template>  

                    <template v-slot:cell(quantity)="data">                                  
                      <div v-if="data.item.service.mode=='hours'">
                        {{data.item.quantity}} {{data.item.service.mode}}
                      </div>                          
                    </template>                                                      

                    <template v-slot:cell(price)="data">   
                      <span v-if="data.item.price_list">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.price_list.currency.code}).format(data.item.price)}}
                      </span>
                      <span v-else>                        
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(data.item.price)}}
                      </span>                      
                    </template>

                    <template v-slot:cell(total)="data">                                                      
                      <span v-if="data.item.price_list">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.price_list.currency.code}).format(getTotalService(data.item))}}
                      </span>
                      <span v-else>
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(getTotalService(data.item))}}
                      </span>
                    </template>

                    <template v-slot:cell(total_renewal)="data">                                                      
                      <span class="font-italic">
                        <span v-if="data.item.service.list">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.service.list.currency.code}).format(getTotalRenewalService(data.item))}}
                        </span>
                        <span v-else>
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(getTotalRenewalService(data.item))}}
                        </span>
                      </span>
                    </template>                    

                    <template v-slot:cell(full_sale)="data">                     
                      <div v-if="data.item.full_sale" v-b-tooltip.hover :title="data.item.full_sale">
                        <b-icon icon="receipt" style="width: 15px; height: 15px; cursor:pointer;" variant="dark"></b-icon>
                      </div>                       
                    </template>  

                    <template v-slot:cell(date_renewal)="data">  
                      <div v-if="data.item.canceled">
                        <b-badge variant="danger">FINALIZADO</b-badge>
                        <div class="crud-services-customers-reasons-canceled">
                          <b-icon icon="exclamation-circle" 
                                  v-if="data.item.canceled" 
                                  class="h4 mb-0" 
                                  v-b-tooltip.hover 
                                  :title="data.item.reasons_canceled" />                           
                        </div>                       
                      </div>

                      <div v-if="!data.item.canceled" class="pl-2 pr-2">
                        <div v-if="daysForRenewal(data.item)<1">
                          <div class="crud-services-vto-danger">                                 
                            {{moment(data.item.date_renewal).format('DD/MM/YYYY')}} 
                            (Vencido por {{daysVtoRenewal(data.item)}} día/s)
                          </div>
                          
                          <span :id="'popover-notification-' + data.item.id" v-if="data.item.date_notification" style="cursor:pointer;">
                            <b>[AVISADO]</b>
                          </span>
                          <b-popover :target="'popover-notification-' + data.item.id" variant="default" triggers="hover" class="popover-notifications">                            
                            <div v-html="previewPopoverNotification(data.item)"></div>
                          </b-popover>                                
                        </div>
                        <div v-else>
                          <div v-if="data.item.date_renewal">
                            <div :class="[daysForRenewal(data.item)<5 ? 'crud-services-vto-warning' : 'crud-services-vto-success']">
                              {{moment(data.item.date_renewal).format('DD/MM/YYYY')}} 
                              <b>(<span v-html="daysForRenewal(data.item)"></span> día/s)</b>                              
                            </div>
                          
                            <span :id="'popover-notification-' + data.item.id" v-if="data.item.date_notification" style="cursor:pointer;">
                              <b>[AVISADO]</b>
                            </span>
                            <b-popover :target="'popover-notification-' + data.item.id" variant="default" triggers="hover" class="popover-notifications">                            
                              <div v-html="previewPopoverNotification(data.item)"></div>
                            </b-popover>                   
                          </div>          
                        </div>
                        
                        <div v-if="data.item.project_id">
                          <b-link @click="goProject(data.item)"> 
                            <b>
                              <b-icon icon="list-task"></b-icon> Ver Proyecto
                            </b>
                          </b-link>
                        </div>
                      </div>
                    </template>  

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right 
                                  text="" 
                                  size="sm" 
                                  variant="outline-dark" 
                                  class="pull-right"
                                  @show="setConfigTableDisplayServicesShow"
                                  @hide="setConfigTableDisplayServicesHide">
                        
                        <b-dropdown-header v-if="showChangeService(data.item) || showRenewal(data.item) || (moduleSalesActive && showInvoiceService(data.item))">
                          Operaciones
                        </b-dropdown-header>              
                        <b-dropdown-item v-if="showRenewal(data.item)" @click="openRenewal(data.item)">
                          <b-icon icon="arrow-repeat"></b-icon> Renovar Servicio 
                        </b-dropdown-item>                                                                     
                        <b-dropdown-item v-if="showChangeService(data.item)" @click="openChangeService(data.item)">
                          <b-icon icon="arrow-left-right"></b-icon> Cambiar Servicio 
                        </b-dropdown-item>                                         
                        <b-dropdown-item v-if="moduleSalesActive && showInvoiceService(data.item)" @click="generateInvoice(data.item)" >
                          <b-icon icon="file-earmark-ruled"></b-icon> Facturar Servicio
                        </b-dropdown-item>      
                        
                        <b-dropdown-header>
                          Notificaciones
                        </b-dropdown-header>                            
                        <b-dropdown-item @click="generateTextNotificationEmail(data.item)" >
                          <b-icon icon="envelope"></b-icon> Notificación Email
                        </b-dropdown-item>                                                  
                        <b-dropdown-item @click="generateTextNotificationWhatsapp(data.item)" >
                          <b-icon icon="whatsapp"></b-icon> Notificación Whatsapp
                        </b-dropdown-item>                                                  

                        <b-dropdown-header>Información</b-dropdown-header>                        
                        <b-dropdown-item @click="openPricesServices(data.item)">
                          <b-icon icon="currency-dollar"></b-icon> Precios
                        </b-dropdown-item>                                                      
                        <b-dropdown-item @click="openActivity(data.item)">
                          <b-icon icon="file-ruled-fill"></b-icon> Ver Actividad 
                        </b-dropdown-item>                     
                        <b-dropdown-item @click="openObservations(data.item)">
                          <b-icon icon="card-heading"></b-icon> Observaciones 
                        </b-dropdown-item>                                             

                        <b-dropdown-header>Cancelaciones</b-dropdown-header>
                        <b-dropdown-item @click="openCancel(data.item)" v-if="showCanceled(data.item)">
                          <b-icon icon="dash-circle-fill"></b-icon> Cancelar Servicio 
                        </b-dropdown-item>   
                        <b-dropdown-item @click="restoreServoceCancel(data.item)" v-else>
                          <b-icon icon="arrow-bar-left"></b-icon> Restaurar Servicio 
                        </b-dropdown-item> 
                      </b-dropdown>
                    </template>   

                    <template slot="bottom-row">
                      <td colspan="9" class="display-service-customers-table-foot-legend">
                        Total
                      </td>
                      <td class="display-service-customers-table-foot-total">
                        <div v-if="getTotal" v-html="this.getTotal"></div>
                      </td>
                      <td class="display-service-customers-table-foot-total-renewal">
                        <div v-if="getTotalRenewal" v-html="this.getTotalRenewal"></div>
                      </td>                      
                      <td colspan="3" class="display-service-customers-table-foot-legend"></td>
                    </template>                               
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>   
              </b-col>
            </b-row>
          
            <b-row class="mt-3">              
              <b-col>
                <nav>
                  <b-pagination class="pull-right mb-0"
                                size="sm"
                                pills=""
                                :total-rows="getRowCount(table.items)"
                                :per-page="table.perPage"
                                v-model="table.currentPage" />
                </nav>
              </b-col>          
            </b-row>
          </b-card>        

        </b-tab>
        <b-tab title="Historial" @click="loadServicesCustomersActivitys()">       
          <div v-if="!pivot.isLoader">   
            <Pivot :dataJson="pivot.data" v-if="pivot.data"/> 
          </div>
          <div v-else>   
            <b-spinner type="grow" label="Spinning"></b-spinner>
          </div>
        </b-tab>
      </b-tabs>   

      <b-card header-tag="header" footer-tag="footer" class="mt-3">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>

        </b-row>
      </b-card>   

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD RENOVACION -->
      <b-modal v-model="modal.renewal.active"
              header-bg-variant="dark"
              header-text-variant="white"
              size="md"
              :key="modal.renewal._id"
              :id="modal.renewal._id">                  
        <div slot="modal-header" minimize>
          {{this.modal.renewal.title}}
        </div>

        <b-row>
          <b-col lg="6">            
            <div v-if="crud.renewal.service">
              <b>{{this.crud.renewal.service.name}}</b>
              <br>
              {{this.crud.renewal.name}}
            </div>
          </b-col>          
          <b-col lg="6">            
            <div v-if="crud.renewal.customer">
              <div v-if="crud.renewal.customer.id">             
                <b-avatar :src="crud.renewal.customer.image"
                          v-if="crud.renewal.customer.image">
                </b-avatar>
                <b-avatar v-else 
                          icon="building"                                            
                          variant="dark">
                </b-avatar>     
                &nbsp;<b>{{crud.renewal.customer.name}}</b>      
                <b-icon icon="circle-fill" v-if="!crud.renewal.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col lg="6">
            <b-form-group label="Fecha Renovación">                
              <b-form-datepicker size="sm" v-model="crud.renewal.date_renewal" placeholder="Fecha" local="es" disabled></b-form-datepicker>                      
            </b-form-group>            
          </b-col>      
          <b-col lg="6">
            <b-form-group label="Próxima Renovación">                
              <b-form-datepicker size="sm" v-model="crud.renewal.date_next_renewal" placeholder="Fecha" local="es"></b-form-datepicker>                      
            </b-form-group>            
          </b-col>                    
        </b-row>

        <b-row class="mt-3">
          <b-col md="6">
            <legend class="display-services-customer-form-renewal-period-legend">
              Período de Renovación
            </legend>
            <span>CADA <u>{{this.crud.renewal.period}}</u></span>
          </b-col>
          <b-col md="6">
            <b-form-group label="Importe">
              <b-input-group :prepend="crud.renewal.currency">
                <b-form-input type="number"
                              v-model="crud.renewal.price"
                              step="0.01"                          
                              placeholder="Ingresar el precio">
                </b-form-input>
              </b-input-group>
            </b-form-group>            
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.renewal.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveRenewal()">Aceptar</b-button>          
        </div>
      </b-modal>

      <!-- CRUD ACTIVIDAD -->
      <b-modal v-model="modal.activity.active"
              header-bg-variant="dark"
              header-text-variant="white"
              size="lg">
        <div slot="modal-header">
          {{this.modal.activity.title}}
        </div>

        <b-row>
          <b-col lg="6">            
            <div v-if="arr.servicesCustomersActivitys.service">
              <b>{{this.arr.servicesCustomersActivitys.service.name}}</b>
              <br>
              {{this.arr.servicesCustomersActivitys.name}}
            </div>
          </b-col>          
          <b-col lg="6">            
            <div v-if="arr.servicesCustomersActivitys.customer">
              <div v-if="arr.servicesCustomersActivitys.customer.id">             
                <b-avatar :src="arr.servicesCustomersActivitys.customer.image"
                          v-if="arr.servicesCustomersActivitys.customer.image">
                </b-avatar>
                <b-avatar v-else 
                          icon="building"                                            
                          variant="dark">
                </b-avatar>     
                &nbsp;<b>{{arr.servicesCustomersActivitys.customer.name}}</b>      
                <b-icon icon="circle-fill" v-if="!arr.servicesCustomersActivitys.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-table class="mt-2 mb-0 display-services-customer-table-activity"
              responsive
              head-variant="dark"
              :hover="true"
              :small="true"
              :fixed="false"                              
              :items="tableActivity.items"
              :fields="tableActivity.fields"
              v-if="tableActivity.items">  

                <template v-slot:cell(services)="data">  
                  <div v-if="data.item.service">
                    {{data.item.service.name}}
                  </div>
                </template>  

                <template v-slot:cell(date_init)="data">  
                  {{moment(data.item.date_init).format('DD/MM/YYYY')}}
                </template>  

                <template v-slot:cell(date_end)="data">  
                  <div v-if="data.item.date_end">
                    {{moment(data.item.date_end).format('DD/MM/YYYY')}}
                  </div>
                </template>  

                <template v-slot:cell(price)="data">   
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.currency}).format(data.item.price)}}
                </template>

                <template v-slot:cell(sale_id)="data">                     
                  <div v-if="data.item.sale_id" v-b-tooltip.hover :title="data.item.sale.type_voucher.name + ' ' + data.item.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + data.item.sale.number.toString().padStart(8,'0')">
                    <b-icon icon="receipt" style="width: 15px; height: 15px; cursor:pointer;" variant="dark"></b-icon>
                  </div>                       
                </template>

                <template v-slot:cell(f_action)="data">                                       
                  <b-dropdown right   
                              text="Acción" 
                              size="sm" 
                              variant="outline-dark" 
                              class="pull-right"
                              v-if="!arr.servicesCustomersActivitys.canceled">                    
                    <b-dropdown-item @click="removeActivity(data.item)">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>   
          </b-col>          
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.activity.active=false">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CRUD CANCEL -->
      <b-modal v-model="modal.cancel.active"
              header-bg-variant="dark"
              header-text-variant="white"
              size="md">
        <div slot="modal-header">
          {{this.modal.cancel.title}}
        </div>

        <b-row>
          <b-col lg="12">
            <b-form-group label="Fecha Finalización">                
              <b-form-datepicker size="sm" v-model="crud.cancel.date_end" placeholder="Fecha" local="es"></b-form-datepicker>                      
            </b-form-group>            
          </b-col>
          <b-col lg="12">
            <b-form-group label="Motivos de Cancelación">
              <app-textarea                
                v-model="crud.cancel.reasons_canceled"
                rows="3"
                max-rows="6"
              ></app-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.cancel.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveCancel()">Aceptar</b-button>          
        </div>
      </b-modal>

      <!-- CRUD OBSERVATIONS -->
      <b-modal v-model="modal.observations.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close         
              header-bg-variant="dark"
              header-text-variant="white"
              size="xl"
              :key="modal.observations._id"
              :id="modal.observations._id">                  
        <div slot="modal-header" minimize>
          {{this.modal.observations.title}}
        </div>

        <b-row>
          <b-col lg="6">            
            <div v-if="crud.observations.service">
              <b>{{this.crud.observations.service.name}}</b>
              <br>
              {{this.crud.observations.name}}
            </div>
          </b-col>          
          <b-col lg="6">            
            <div v-if="crud.observations.customer">
              <div v-if="crud.observations.customer.id">             
                <b-avatar :src="crud.observations.customer.image"
                          v-if="crud.observations.customer.image">
                </b-avatar>
                <b-avatar v-else 
                          icon="building"                                            
                          variant="dark">
                </b-avatar>     
                &nbsp;<b>{{crud.observations.customer.name}}</b>      
                <b-icon icon="circle-fill" v-if="!crud.observations.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
              </div>
            </div>
          </b-col>

          <b-col lg="12">
            <hr>
          </b-col>        

          <b-col lg="12">
            <b-form-group label="Observaciones">
              <vue-editor class="display-observations-ql-editor" v-model="crud.observations.observations"></vue-editor>              
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.observations.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveObservations()">Guardar</b-button>          
        </div>
      </b-modal>

      <!-- CRUD SERVICES -->
      <b-modal v-model="modal.service.active"              
              header-bg-variant="dark"
              header-text-variant="white"
              size="md">
        <div slot="modal-header">
          {{this.modal.service.title}}
        </div>

        <b-row>
          <b-col lg="6">            
            <div v-if="crud.service.service">
              <b>{{this.crud.service.service.name}}</b>
              <br>
              {{this.crud.service.name}}
            </div>
          </b-col>          
          <b-col lg="6">            
            <div v-if="crud.service.customer">
              <div v-if="crud.service.customer.id">             
                <b-avatar :src="crud.service.customer.image"
                          v-if="crud.service.customer.image">
                </b-avatar>
                <b-avatar v-else 
                          icon="building"                                            
                          variant="dark">
                </b-avatar>     
                &nbsp;<b>{{crud.service.customer.name}}</b>      
                <b-icon icon="circle-fill" v-if="!crud.service.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
              </div>
            </div>
          </b-col>

          <b-col lg="12">
            <hr>
          </b-col>      
          <b-col lg="12">
            <FindObject render="search"
                        type="services" 
                        @select-object="loadServices($event)" 
                        :valueID="crud.service.services_id"
                        :where="conditionServicesActive"/>             
          </b-col>   

          <b-col lg="12">
            <FindObject render="search"
                        type="priceList" 
                        @select-object="loadPriceList($event)" 
                        :valueID="crud.service.price_list_id"/>             
          </b-col>   

          <b-col lg="12">
            <b-form-group label="Fecha Renovación">                
              <b-form-datepicker size="sm" v-model="crud.service.date_renewal" placeholder="Fecha Renovación" local="es"></b-form-datepicker>                      
            </b-form-group>            
          </b-col>      
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.service.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveChangeService()">Cambiar</b-button>          
        </div>
      </b-modal>     

      <!-- PRECIOS -->
      <b-modal v-model="modal.price.active"
              header-bg-variant="dark"
              header-text-variant="white">
        <div slot="modal-header">
          {{this.modal.price.title}}
        </div>

        <b-row>
          <b-col lg="12">            
            <div v-if="crud.price.customer">
              <div v-if="crud.price.customer.id">             
                <b-avatar :src="crud.price.customer.image"
                          v-if="crud.price.customer.image">
                </b-avatar>
                <b-avatar v-else 
                          icon="building"                                            
                          variant="dark">
                </b-avatar>     
                &nbsp;<b>{{crud.price.customer.name}}</b>      
                <b-icon icon="circle-fill" v-if="!crud.price.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
              </div>
            </div>
          </b-col>
          <b-col lg="12">            
            <div v-if="crud.price.service">
              <b>{{this.crud.price.service.name}}</b>
              <br>
              {{this.crud.price.name}}
            </div>
          </b-col>                    
        </b-row>
        <b-row class="mt-3">
          <b-col lg="12">
            <b-table class="mt-2 mb-0"
              responsive
              head-variant="dark"
              :hover="true"
              :small="true"
              :fixed="false"                              
              :items="tablePrice.items"
              :fields="tablePrice.fields"
              v-if="tablePrice.items.length">  

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 
              
              <template v-slot:cell(list)="data">                
                <div v-if="data.item.list">
                  {{data.item.list.name}}
                  <span v-if="data.item.list.public" class="crud-services-list-prices-public">
                    (Pública)
                  </span>
                </div>
              </template>                                        

              <template v-slot:cell(asignado)="data">                                
                <b-badge variant="secondary" 
                          v-if="data.item.price_list_id == crud.price.itemDetail.price_list_id">
                  Asignado
                </b-badge>                
              </template>        
              
              <template v-slot:cell(price)="data">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total)}}                
              </template>

            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>   
          </b-col>          
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.price.active=false">Cancelar</b-button>
        </div>
      </b-modal>       

      <!-- NOTIFICACIONES -->
      <b-modal v-model="modal.notification.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close         
              header-bg-variant="dark"
              header-text-variant="white"
              size="xl"
              :key="modal.notification._id"
              :id="modal.notification._id">                  
        <div slot="modal-header" minimize>
          {{this.modal.notification.title}}
        </div>

        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-message variant="secondary" class="text-left">
                <b>MENSAJE DE NOTIFICACIÓN</b>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-message" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-form-group label="Fecha Notificación" description="Fecha en la que se envió la notificación">
                  <b-form-datepicker size="sm" v-model="modal.notification.date" placeholder="Fecha Notificación" local="es"></b-form-datepicker>                      
                </b-form-group>   
                <b-form-group description="Al dejar vacío el campo, se eliminará la notificación">
                  <vue-editor class="display-observations-ql-editor" v-model="modal.notification.message"></vue-editor>              
                </b-form-group>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1" v-if="modal.notification.customer">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-contact variant="secondary" class="text-left">
                <b>CONTACTOS DEL CLIENTE</b>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-contact" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-col lg="12">
                  <Contacts :customers="modal.notification.customer" :customersID="modal.notification.customer.id"></Contacts>
                </b-col>                
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <div slot="modal-footer">
          <b-button variant="warning" class="mr-1" @click="modal.notification.active=false">Salir</b-button>    
          <b-button variant="dark" @click="saveNotification()" v-if="!modal.notification.all">Guardar</b-button>                
          <b-button variant="dark" @click="saveNotificationAll()" v-if="modal.notification.all">Guardar</b-button>                
        </div>
      </b-modal>      
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Param from '@/config/parameters'
  import moment from 'moment'
  import Storage from '@/handler/storageLocal'
  import Pivot from '@/components/inc/pivot/index'
  import { VueEditor } from "vue2-editor";
  import FindObject from '@/components/inc/find/findObject'
  import Function from '@/handler/funciones'  
  import Contacts from '@/components/modules/users/_access/customer/staff/contacts/crud'

  export default {
    components: { 
      Pivot,
      VueEditor,
      FindObject,
      Contacts,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.SERVICIOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'displayServicesCustomers',
          elements: {}
        }, 
        table : {
          items: [],
          fields: [
            {key: 'customers', label: 'Cliente', class:"align-middle", width:"150px"},                        
            {key: 'renewal', label: '', class:"align-middle", width:"25px"},                    
            {key: 'services', label: 'Servicio', class:"align-middle", width:"150px"},            
            {key: 'observations', label: '', class:"align-middle", width:"20px"},                        
            {key: 'date_init', label: 'Inicio', class:"align-middle text-center", width:"100px"},            
            {key: 'date_end', label: 'Fin', class:"align-middle text-center", width:"10px"},            
            {key: 'list', label: 'Lista', class:"align-middle text-center", width:"75px"},
            {key: 'quantity', label: 'Cantidad', class:"align-middle text-center", width:"75px"},            
            {key: 'price', label: 'Importe', class:"align-middle text-right", width:"100px"},     
            {key: 'total', label: 'Total', class:"align-middle text-right", width:"100px"},     
            {key: 'total_renewal', label: 'Renovación', class:"align-middle text-right", width:"100px"},     
            {key: 'full_sale', label: '', class:"align-middle text-center", width:"20px"},                         
            {key: 'date_renewal', label: '', class:"align-middle text-center", width:"140px"},
            {key: 'f_action', label:'', class:"align-middle", width:"20px"},
          ],
          mostrarFiltros: true,
          currentPage: 1,
          perPage: 50,
          isBusy: false,          
        },         
        tableActivity: {
          items: [],
          fields: [
            {key: 'services', label: 'Servicio', class:"align-middle", width:"150px"},            
            {key: 'date_end', label: 'Renovación', class:"align-middle text-left", width:"100px"},                        
            {key: 'date_init', label: 'Inicio', class:"align-middle text-left", width:"100px"},                        
            {key: 'price', label: 'Total', class:"align-middle text-right", width:"100px"},                 
            {key: 'sale_id', label: '', class:"align-middle text-center", width:"50px"},                 
            {key: 'f_action', label:'', class:"align-middle", width:"50px"},
          ],
        }, 
        tablePrice: {
          items: [],
          fields: [
            {key: 'list', label: 'Lista', class:"align-middle", width:"250px"},
            {key: 'price', label: 'Precio', class:"align-middle", width:"100px"},
            {key: 'asignado', label: '', class:"align-middle text-right", width:"100px"},
          ],
        },
        crud: {        
          renewal: {
            id: 0,
            date_renewal: '',
            date_next_renewal: '',
            name: '',
            customer: null,
            service: null,
            period: '',
            currency: '',
            price: 0,
          },
          cancel: {
            id: 0,
            reasons_canceled: '',
            date_end: ''
          },
          observations: {
            id: 0,
            name: '',
            service: null,
            customer: null,
            observations: '',
          },
          service: {
            id: 0,
            name: '',
            service: null,
            services: null,
            services_id: 0,
            customer: null,            
            date_renewal: '',
            price_list_id: 0,
            price_list : null,
          },
          price: {
            id: 0,            
            name: '',
            service: null,
            customer: null,    
            itemDetail: null                    
          }
        },            
        modal: {
          renewal: {
            active: false,
            title: ''
          },
          activity: {
            active: false,
            title: ''
          },
          cancel: {
            active: false,
            title: ''
          },      
          observations: {
            active: false,
            title: ''            
          },
          service: {
            active: false,
            title: ''            
          },
          price: {
            active: false,
            title: ''
          },
          notification: {
            active: false,
            title: '',
            id: 0,
            date: null,
            message: '',
            customer: null,
            all: false,
          },          
        },  
        arr: {
          servicesCustomersDetails: [],
          servicesCustomersActivitys: {
            name: '',
            customer: null,
            service: null,
            canceled: false,
          },
          filter : {
            services: [],
            customers: [],
            status: [
              {code:false, label: 'Activo'},
              {code:true, label: 'Finalizado'},                
            ],
          },
        },
        filter: {
          services: [],
          customers: [],
          status: [
            {code:false, label: 'Activo'}
          ],
        },           
        pivot: {
          data: null,
          isLoader: true,          
        },     
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {     
      this.filterLoad() 
      this.filterServicesCustomersDetails()      

      this._start = true
    }, 
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 
            
      this.filterLoad() 
      this.filterServicesCustomersDetails()      
    },         
    computed: {
      moduleSalesActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.VENTAS) {                             
            status = true                       
          }
        })        
        return status
      },
      onlyOneCustomerFilter() {
        let arrID = []
        if(this.arr.servicesCustomersDetails && this.arr.servicesCustomersDetails.length > 0) {
          this.arr.servicesCustomersDetails.forEach(element => {            
            arrID[element.service_customer.customer_id] = 0
          });
        }
        arrID = Object.keys(arrID)        
        if(arrID.length == 1) {
          return true
        } else {
          return false
        }
      },  

      conditionServicesActive() {
        return [
          {field: 'active', condition: true},
          {field: 'show_only_erp', condition: false}
        ];
      },
            
      getTotal() {
        //obtengo las diferentes monedas
        var currency = []
        this.arr.servicesCustomersDetails.forEach(element => {
          if(element.service.list) {
            if(element.service.list.currency.code) {
              var code = element.service.list.currency.code
              if(!currency.includes(code)) {
                currency[code] = 0
              }
            }
          }                    
        })
        
        // sumo totales por monedas
        this.arr.servicesCustomersDetails.forEach(element => {
          if(element.service.list) {
            if(element.service.list.currency.code) {
              var code = element.service.list.currency.code

              if(element.quantity) {
                currency[code] = currency[code] + (parseFloat(element.price) * parseFloat(element.quantity))
              } else {
                currency[code] = currency[code] + parseFloat(element.price)
              }

            }
          }          
        });   
        
        //armo html para mostrar total                
        var htmlResult = ''
        if(currency) {          
          for(let prop of Object.keys(currency)) {
            htmlResult = htmlResult + Intl.NumberFormat('es-AR',{style:'currency',currency:prop}).format(currency[prop]) + '<br>'
          }          
        }
        return htmlResult        
      },     

      getTotalRenewal() {
        //obtengo las diferentes monedas
        var currency = []
        this.arr.servicesCustomersDetails.forEach(element => {
          if(element.service.list) {
            if(element.service.list.currency.code) {
              var code = element.service.list.currency.code
              if(!currency.includes(code)) {
                currency[code] = 0
              }
            }
          }                    
        })
        
        // sumo totales por monedas
        this.arr.servicesCustomersDetails.forEach(element => {
          if(element.service.list) {
            if(element.service.list.currency.code) {
              var code = element.service.list.currency.code

              if(element.quantity) {
                currency[code] = currency[code] + (parseFloat(element.service.price_simple) * parseFloat(element.quantity))
              } else {
                currency[code] = currency[code] + parseFloat(element.service.price_simple)
              }

            }
          }          
        });   
        
        //armo html para mostrar total                
        var htmlResult = ''
        if(currency) {          
          for(let prop of Object.keys(currency)) {
            htmlResult = htmlResult + Intl.NumberFormat('es-AR',{style:'currency',currency:prop}).format(currency[prop]) + '<br>'
          }          
        }
        return htmlResult             
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },    
      load() {
        var result = serviceAPI.obtenerServicesCustomersDetails()

        result.then((response) => {
          var data = response.data
          this.table.items = data             
          
          this.arr.servicesCustomersDetails = data
          
          this.table.isBusy = false
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },
  
      filterLoad() {
        this.filterLoadCustomers()        
        this.filterLoadServices()

        this.restoreFilterStorage() 
      },
      filterLoadServices() {
        var result = serviceAPI.obtenerServices()        
        result.then((response) => {
          var data = response.data    

          this.arr.filter.services = []
          let arrActive = []
          let arrInactive = []                    
          data.forEach(element => {           
            if(!element.show_only_erp) {
              if(element.active) 
                arrActive.push({ code: element.id, label: element.category.name + " - " + element.name })            
              else
                arrInactive.push({ code: element.id, label: '[INACTIVO] - ' + element.category.name + " - " + element.name })            
            }
          });      
          this.arr.filter.services = arrActive.concat(arrInactive);        
        })   
      },      
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()        
        result.then((response) => {
          var data = response.data    
          
          let arrActive = []
          let arrInactive = []          
          data.forEach(element => {            
            if(element.active)
              arrActive.push({ code: element.id, label: element.name })            
            else 
              arrInactive.push({ code: element.id, label: '[INACTIVO] - ' + element.name })                                    
          });      
          this.arr.filter.customers = arrActive.concat(arrInactive);    
        })   
      },
      filterServicesCustomersDetails(){    
        this.saveFilterStorage()

        this.table.isBusy = true 
   
        var result = serviceAPI.filtrarServiceCustomersDetails(this.filter)        
        result.then((response) => {     
          var data = response.data
          this.table.items = data
          this.arr.servicesCustomersDetails = data
          
          this.table.isBusy = false
        })
        .catch(error => {             
          this.table.isBusy = false          
          this.$awn.alert(Error.showError(error))
        });          
      },  

      setConfigTableDisplayServicesShow() {
        var arrTable = document.getElementsByClassName('table-displat-services-custom')
        var i = 0
        for(i=0; i<arrTable.length; i++) {          
          arrTable[i].style.minHeight = '400px'
        }        
      },
      setConfigTableDisplayServicesHide() {
        var arrTable = document.getElementsByClassName('table-displat-services-custom')
        var i = 0
        for(i=0; i<arrTable.length; i++) {
          arrTable[i].style.minHeight = 'auto'
        }        
      },        
      
      openRenewal(item) {                     
        this.crud.renewal.id = item.id
        this.crud.renewal.date_renewal = item.date_renewal       
        this.crud.renewal.customer = item.service_customer.customer
        this.crud.renewal.service = item.service
        this.crud.renewal.name = item.service_customer.name
        this.crud.renewal.period = item.service.renewal + ' ' + this.getModeName(item.service.mode)        
        this.crud.renewal.currency = item.service.list.currency.symbol
        this.crud.renewal.price = item.service.price_simple
        
        switch (item.service.mode) {
          case 'days':
            this.crud.renewal.date_next_renewal = moment(item.date_renewal).add(item.service.renewal, 'days').format('YYYY-MM-DD')
            break;
        
          case 'months':
            this.crud.renewal.date_next_renewal = moment(item.date_renewal).add(item.service.renewal, 'months').format('YYYY-MM-DD')
            break;

          case 'years':
            this.crud.renewal.date_next_renewal = moment(item.date_renewal).add(item.service.renewal, 'years').format('YYYY-MM-DD')
            break;            
        }
        
        this.modal.renewal._id = Math.random().toString(36).slice(2, 8)
        this.modal.renewal.active = true
        this.modal.renewal.title = "Renovar Servicio"
      },
      saveRenewal() {
        this.$bvModal.msgBoxConfirm('¿Desea renovar el servicio?', {
          title: 'Renovar Servicio',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'dark',
          okTitle: 'RENOVAR',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {                
            let loader = this.$loading.show();
            var result = serviceAPI.renewalServicesCustomersDetails(this.crud.renewal);

            result.then((response) => {      
              this.modal.renewal.active = false        
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Servicio Renovado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })          
      },
      
      openActivity(item) {                
        this.tableActivity.items = [...item.activitys].reverse()
        this.arr.servicesCustomersActivitys.customer = item.service_customer.customer
        this.arr.servicesCustomersActivitys.service = item.service
        this.arr.servicesCustomersActivitys.name = item.service_customer.name
        this.arr.servicesCustomersActivitys.canceled = item.canceled
                
        this.modal.activity.active = true
        this.modal.activity.title = "Actividad del servicio"
      },
      removeActivity(item) {        
        var service = 'servicio ' + (item.service ? item.service.name : '');
        var customer = 'cliente ' + (item.customer ? item.customer.name : '')
        var period = 'periodo ' + moment(item.date_init).format('DD/MM/YYYY') + ' - ' + moment(item.date_end).format('DD/MM/YYYY')

        this.$bvModal.msgBoxConfirm('¿Desea cancelar el ' + period + ' correspondiente al ' + service + ' asignado al ' + customer + '?', {
          title: 'Cancelar Actividad',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();            

            var result = serviceAPI.eliminarServicesCustomersActivity(item.id);

            result.then((response) => {      
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Registro eliminado");
              this.modal.activity.active = false
            })
            .catch(error => {              
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          } 
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error));
        })
      },

      openObservations(item) {
        this.crud.observations.id = item.id
        this.crud.observations.observations = item.observations
        this.crud.observations.name = item.service_customer.name
        this.crud.observations.service = item.service
        this.crud.observations.customer = item.service_customer.customer

        this.modal.observations._id = Math.random().toString(36).slice(2, 8)
        this.modal.observations.active = true
        this.modal.observations.title = "Observaciones del Servicio"
      },
      saveObservations() {
        this.$bvModal.msgBoxConfirm('¿Guardar Observaciones?', {
          title: 'Observaciones',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'dark',
          okTitle: 'GUARDAR',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {                
            let loader = this.$loading.show();
            
            var result = serviceAPI.editarObservacionesServicesCustomersDetails(this.crud.observations);

            result.then((response) => {                    
              this.modal.observations.active = false        
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Observaciones Guardada");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })            
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        }) 
      },
      previewPopoverObservations(item) {
        let style = '<style>p, ul {margin-bottom: 5px !important;}</style>'
        let observations = item.observations

        return style + observations
      },      

      openChangeService(item) {
        this.crud.service.id = item.id        
        this.crud.service.services = item.service
        this.crud.service.services_id = item.service.id
        this.crud.service.date_renewal = item.date_renewal

        this.crud.service.service = item.service
        this.crud.service.name = item.service_customer.name        
        this.crud.service.customer = item.service_customer.customer

        if(item.price_list) {
          this.crud.service.price_list = item.price_list
          this.crud.service.price_list_id = item.price_list.id
        } else {
          this.crud.service.price_list = null
          this.crud.service.price_list_id = 0
        }

        this.modal.service.active = true
        this.modal.service.title = "Cambio de Servicio"
      },      
      saveChangeService() {
        this.$bvModal.msgBoxConfirm('¿Cambiar Servicio?', {
          title: 'Servicio',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'dark',
          okTitle: 'CAMBIAR',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {                
            let loader = this.$loading.show();
            
            var result = serviceAPI.cambiarServicesServicesCustomersDetails(this.crud.service);

            result.then((response) => {                    
              this.modal.service.active = false        
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Servicio cambiado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })                        
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        }) 
      },
      loadServices(object) {
        if(object){
          this.crud.service.services = object
          this.crud.service.services_id = object.id                    
        } else {
          this.crud.service.services = null
          this.crud.service.services_id = 0                              
        }
      },
      loadPriceList(object) {
        if(object){
          this.crud.service.price_list = object
          this.crud.service.price_list_id = object.id                    
        } else {
          this.crud.service.price_list = null
          this.crud.service.price_list_id = 0                              
        }
      },            

      daysForRenewal(item) {        
        var date1 = moment();
        var date2 = moment(item.date_renewal);

        return date2.diff(date1, 'days') + 1;
      },
      daysVtoRenewal(item) {        
        var date1 = moment(item.date_renewal);
        var date2 = moment();

        return date2.diff(date1, 'days') + 1;
      },        
      getTotalService(item) {
        if(item.quantity) {
          return item.quantity * item.price
        } else {
          return item.price
        }
      },
      getTotalRenewalService(item) {        
        if(item.quantity) {
          return item.quantity * item.service.price_simple
        } else {
          return item.service.price_simple
        }
      },

      showChangeService(item) {
        return !item.canceled
      },
      showInvoiceService(item) {
        return !item.canceled
      },
      showRenewal(item) {
        return (item.service.mode=='days' || 
                item.service.mode=='months' || 
                item.service.mode=='years') && 
                !item.service.automatic_renewal &&
                !item.canceled        
      },
      showCanceled(item) {        
        if( !item.canceled && 
            (item.service.mode!='units' && item.service.mode!='hours') ) {
          return true
        } else {
          return false
        }
      },

      openPricesServices(item) {        
        this.crud.price.id = item.id
        this.crud.price.observations = item.observations
        this.crud.price.name = item.service_customer.name
        this.crud.price.service = item.service
        this.crud.price.customer = item.service_customer.customer
        this.crud.price.itemDetail = item
                
        this.tablePrice.items = this.orderPriceListByUtility(item.service.prices)        
        this.tablePrice.items.forEach(element => {                      
          if(item.price_list_id == element.price_list_id) {
            element._rowVariant = 'info'
          }            
        });
        
        this.modal.price.active = true
        this.modal.price.title = "Precios"
      },
      orderPriceListByUtility(arrData) {
        let arrSort = arrData.map(item => {          
          return {
            ...item,
            utility: parseFloat(item.list.utility),
            currency_id: item.list.currency_id
          };
        });

        return Function.sortArrayIntegerMultiField(arrSort, ['currency_id','utility'], 1)
      },

      openCancel(item) {
        this.crud.cancel.id = item.id
        this.crud.cancel.date_end = moment().format('YYYY-MM-DD')
        this.crud.cancel.reasons_canceled = ''
        
        this.modal.cancel.active = true
        this.modal.cancel.title = "Cancelar Servicio"
      },
      saveCancel() {
        this.$bvModal.msgBoxConfirm('¿Desea cancelar el servicio?', {
          title: 'Cancelar Servicios',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'ACEPTAR',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {      
            let loader = this.$loading.show();
            var result = serviceAPI.cancelarServicesCustomersDetails(this.crud.cancel);

            result.then((response) => {      
              this.modal.cancel.active = false        
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Servicio Cancelado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })          
      },
      restoreServoceCancel(item) {
        this.$bvModal.msgBoxConfirm('¿Desea restaurar el servicio?', {
          title: 'Restaurar Servicios',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'info',
          okTitle: 'RESTAURAR',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'info',
          headerTextVariant: 'black',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {      
            let loader = this.$loading.show();            
            
            this.crud.cancel.id = item.id            
            var result = serviceAPI.restaurarServicesCustomersDetails(this.crud.cancel);

            result.then((response) => {      
              this.modal.cancel.active = false        
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Servicio Restaurado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })          
      },   

      getModeName(mode) {
        let nameMode = ''

        switch (mode) {
          case 'units':
            nameMode = 'UNIDAD/ES'
            break;
          
          case 'hours':
            nameMode = 'HORA/S'
            break;

          case 'days':
            nameMode = 'DÍA/S'
            break;

          case 'months':
            nameMode = 'MES/ES'
            break;

          case 'years':
            nameMode = 'AÑO/S'
            break;            
        }

        return nameMode
      },

      // PROCESS ADMINISTRATIVE      
      generateInvoice(item) {
        this.$router.push({ 
          name: 'SalesStaffSalesGenerateByServiceCustomer', 
          params: {
            serviceCustomerID: item.id
          },
          query: {            
            customers_id: item.service_customer.customer_id,
            customers: JSON.stringify(item.service_customer.customer),                        
            detail: JSON.stringify([
              {
                quantity: 1, 
                service: item.service,
                services: item.service,
                currency: item.price_list.currency.code,
                price: item.price,                
                description: item.name,
                price_list: item.price_list,                
              }
            ])
          } 
        })
      },
      generateInvoiceAll() {
        let serviceCustomerID = []
        let customer = null
        let query = []
        if(this.arr.servicesCustomersDetails && this.arr.servicesCustomersDetails.length > 0) {
          
          customer = this.arr.servicesCustomersDetails[0].service_customer.customer

          this.arr.servicesCustomersDetails.forEach(item => {       
            serviceCustomerID.push(item.id)

            query.push(
              {
                quantity: 1, 
                service: item.service,
                services: item.service,
                currency: item.price_list.currency.code,
                price: item.price,                
                description: item.name,
                price_list: item.price_list,                
              }
            )
          });
        }

        this.$router.push({ 
          name: 'SalesStaffSalesGenerateByServiceCustomer', 
          params: {
            serviceCustomerID: serviceCustomerID.join(',')
          },
          query: {            
            customers_id: customer.id,
            customers: JSON.stringify(customer),                        
            detail: JSON.stringify(query)
          } 
        })
      },

      //NOTIFICATIONS
      previewPopoverNotification(item) {
        let style = '<style>p, ul {margin-bottom: 0px !important;}</style>'        
        let message = item.message_notification

        let date1 = moment(item.date_notification);
        let date2 = moment();
        let diffDays = date2.diff(date1, 'days');
        let date = '' 
        
        if(diffDays == 0) {
          date = `<p><u>NOTIFICACIÓN</u>: Hoy</p>`
        } else if(diffDays == 1) {
            date = `<p><u>NOTIFICACIÓN</u>: Hace ${diffDays} día</p>`          
        } else {
          date = `<p><u>NOTIFICACIÓN</u>: Hace ${diffDays} días</p>`
        }        

        return style + date + '<hr>' + message
      },      
      generateTextNotificationEmail(item) {
        let text_1 = '<p>Hola <b>' + item.service_customer.customer.name + '</b>, espero que estés bien!</p><br>'                  
        let text_2 = '<p>En unos días se vencen los siguientes <b>servicios anuales</b> vinculados al dominio: <b>' + item.service_customer.name + '</b></p><br>'                  
        let text_3 = '<ul><li>' + item.service.display_sales_detail + '</li></ul><br>'                  
        let text_4 = '<p>El vencimiento es el próximo <b>' + moment(item.date_renewal).format('DD') + ' de ' + moment(item.date_renewal).format('MMMM') + '</b></p><br>'
        let text_5 = '<p>Costo renovación anual: <b>' +  Intl.NumberFormat('es-AR',{style:'currency',currency:item.price_list.currency.code}).format(this.getTotalRenewalService(item)) + '</b></p><br>'
        let text_6 = '<p>Confirmás renovación?</p><br>'
        let text_7 = '<p>Saludos</p>'

        this.modal.notification.id = item.id
        this.modal.notification.date = moment().format('YYYY-MM-DD')
        this.modal.notification.customer = item.service_customer.customer
        this.modal.notification.message = text_1 + text_2 + text_3 + text_4 + text_5 + text_6 + text_7
        this.modal.notification._id = Math.random().toString(36).slice(2, 8)
        this.modal.notification.title = 'Notificación por Email - Renovación de Servicio'
        this.modal.notification.active = true     
        this.modal.notification.all = false   
      },
      generateTextNotificationEmailAll() {        
        if(this.arr.servicesCustomersDetails && this.arr.servicesCustomersDetails.length > 0) {
          let item = this.arr.servicesCustomersDetails[0]
          let arrItem = this.arr.servicesCustomersDetails

          let text_1 = '<p>Hola <b>' + item.service_customer.customer.name + '</b>, espero que estés bien!</p><br>'                  
          let text_2 = '<p>En unos días se vencen los siguientes <b>servicios anuales</b> vinculados al dominio: <b>' + item.service_customer.name + '</b></p><br>'                  

          let text_3 = '<ul>'
          arrItem.forEach(element => {
            text_3 = text_3 + '<li>' + element.service.display_sales_detail + '</li>'    
          });
          text_3 = text_3 + '</ul><br>'

          const dateMin = new Date(Math.min(...arrItem.map(element => new Date(element.date_renewal))));          
          let text_4 = '<p>El vencimiento es el próximo <b>' + moment(dateMin).format('DD') + ' de ' + moment(dateMin).format('MMMM') + '</b></p><br>'        

          const sumTotal = arrItem.reduce((acum, item) => acum + this.getTotalRenewalService(item), 0);
          let text_5 = '<p>Costo renovación anual: <b>' +  Intl.NumberFormat('es-AR',{style:'currency',currency:item.price_list.currency.code}).format(sumTotal) + '</b></p><br>'

          let text_6 = '<p>Confirmás renovación?</p><br>'
          let text_7 = '<p>Saludos</p>'

          this.modal.notification.id = arrItem.map(obj => obj.id);
          this.modal.notification.date = moment().format('YYYY-MM-DD')
          this.modal.notification.customer = item.service_customer.customer
          this.modal.notification.message = text_1 + text_2 + text_3 + text_4 + text_5 + text_6 + text_7
          this.modal.notification._id = Math.random().toString(36).slice(2, 8)
          this.modal.notification.title = 'Notificación por Email - Renovación de Servicio'
          this.modal.notification.active = true   
          this.modal.notification.all = true
        } else {
          this.$awn.alert("No se encontraron servicios para notificar");
        }     
      },
      generateTextNotificationWhatsapp(item) {
        let text_1 = 'Hola *' + item.service_customer.customer.name + '*, espero que estés bien!\n\n'                  
        let text_2 = 'En unos días se vencen los siguientes *servicios anuales* vinculados al dominio: *' + item.service_customer.name + '*\n\n'                  
        let text_3 = '- ' + item.service.display_sales_detail + '\n\n'                  
        let text_4 = 'El vencimiento es el próximo *' + moment(item.date_renewal).format('DD') + ' de ' + moment(item.date_renewal).format('MMMM') + '*\n\n'
        let text_5 = 'Costo renovación anual: *' +  Intl.NumberFormat('es-AR',{style:'currency',currency:item.price_list.currency.code}).format(this.getTotalRenewalService(item)) + '*\n\n'
        let text_6 = 'Confirmás renovación?\n\n'
        let text_7 = 'Saludos'

        this.modal.notification.id = item.id
        this.modal.notification.date = moment().format('YYYY-MM-DD')
        this.modal.notification.customer = item.service_customer.customer
        this.modal.notification.message = text_1 + text_2 + text_3 + text_4 + text_5 + text_6 + text_7
        this.modal.notification._id = Math.random().toString(36).slice(2, 8)
        this.modal.notification.title = 'Notificación por Email - Renovación de Servicio'
        this.modal.notification.active = true
        this.modal.notification.all = false
      },
      generateTextNotificationWhatsappAll() {
        if(this.arr.servicesCustomersDetails && this.arr.servicesCustomersDetails.length > 0) {
          let item = this.arr.servicesCustomersDetails[0]
          let arrItem = this.arr.servicesCustomersDetails        
        
          let text_1 = 'Hola *' + item.service_customer.customer.name + '*, espero que estés bien!\n\n'                  
          let text_2 = 'En unos días se vencen los siguientes *servicios anuales* vinculados al dominio: *' + item.service_customer.name + '*\n\n'                  
          
          let text_3 = ''
          arrItem.forEach(element => {
            text_3 = text_3  + '- ' + element.service.display_sales_detail + '\n'                  
          });
          text_3 = text_3 + '\n'

          const dateMin = new Date(Math.min(...arrItem.map(element => new Date(element.date_renewal))));    
          let text_4 = 'El vencimiento es el próximo *' + moment(dateMin).format('DD') + ' de ' + moment(dateMin).format('MMMM') + '*\n\n'

          const sumTotal = arrItem.reduce((acum, item) => acum + this.getTotalRenewalService(item), 0);
          let text_5 = 'Costo renovación anual: *' +  Intl.NumberFormat('es-AR',{style:'currency',currency:item.price_list.currency.code}).format(sumTotal) + '*\n\n'
          
          let text_6 = 'Confirmás renovación?\n\n'
          let text_7 = 'Saludos'

          this.modal.notification.id = arrItem.map(obj => obj.id);
          this.modal.notification.date = moment().format('YYYY-MM-DD')
          this.modal.notification.customer = item.service_customer.customer
          this.modal.notification.message = text_1 + text_2 + text_3 + text_4 + text_5 + text_6 + text_7
          this.modal.notification._id = Math.random().toString(36).slice(2, 8)
          this.modal.notification.title = 'Notificación por Email - Renovación de Servicio'
          this.modal.notification.active = true
          this.modal.notification.all = true
        } else {
          this.$awn.alert("No se encontraron servicios para notificar");
        }    
      },      
      saveNotification() {      
        let loader = this.$loading.show();            

        var result = serviceAPI.editarNotificacionesServicesCustomersDetails({
          id: this.modal.notification.id,
          date_notification: this.modal.notification.date,
          message_notification: this.modal.notification.message,
        });

        result.then((response) => {                    
          loader.hide()
          this.filterServicesCustomersDetails()
          this.$awn.success("Notificación Guardada");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },
      saveNotificationAll() {      
        let loader = this.$loading.show();            

        var result = serviceAPI.editarNotificacionesServicesCustomersDetailsLote({
          ids: this.modal.notification.id,
          date_notification: this.modal.notification.date,
          message_notification: this.modal.notification.message,
        });

        result.then((response) => {                                  
          loader.hide()
          this.filterServicesCustomersDetails()
          this.$awn.success("Notificaciónes Guardadas");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },      

      // PIVOT
      loadServicesCustomersActivitys() {                        
        if(this.pivot.data)
          return false
        
        var result = serviceAPI.obtenerServicesCustomersActivity()        
        result.then((response) => {
          var data = response.data          
          this.pivot.data = this.processPivot(data)
          this.pivot.isLoader = false
        })                   
      },      
      processPivot(data) {        
        var addData = []        
        data.forEach(element => {          
          addData.push({
            date: element.date,
            customer: (element.customer) ? element.customer.name : '',
            category_service: (element.service && element.service.category) ? element.service.category.name : '',
            service: (element.service) ? element.service.name : '',
            currency: element.currency,
            price: element.price,                        
          })
        });

        return {
          dataSource: {                  
            data: addData,
          },
          slice: {
            rows: [
              {
                uniqueName: "category_service",
                sort: "asc",
              },                 
              {
                uniqueName: "service",
                sort: "asc",
              },              
              {
                uniqueName: "customer",
                sort: "asc",
              },                            
            ],
            columns: [
              {
                uniqueName: "currency",
                sort: "asc",
              },                 
              {
                uniqueName: "date.Year",
                sort: "asc",
              },                  
              {
                uniqueName: "date.Month",
                sort: "asc",
              },                                                                  
            ],
            measures: [
              {
                uniqueName: "price",
                aggregation: "sum"
              },                                   
            ],
            expands: {
              expandAll: false,
              rows: [],
              columns: []
            },
            drills: {
              drillAll: false
            }
          },
          options: {
            grid: {
              type: "compact",
              title: "",
              showFilter: true,
              showHeaders: true,
              showTotals: false,
              showGrandTotals: "off",
              showHierarchies: true,
              showHierarchyCaptions: true,
              showReportFiltersArea: true
            },
            configuratorActive: false,
            configuratorButton: true,
            showAggregations: true,
            showCalculatedValuesButton: true,
            drillThrough: true,
            showDrillThroughConfigurator: true,
            sorting: "on",
            datePattern: "dd/MM/yyyy",
            dateTimePattern: "dd/MM/yyyy HH:mm:ss",
            saveAllFormats: false,
            showDefaultSlice: true,
            defaultHierarchySortName: "asc"
          },
          formats: [
            {
              name: "",
              thousandsSeparator: " ",
              decimalSeparator: ".",
              decimalPlaces: 2,
              maxSymbols: 20,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: " ",
              infinityValue: "Infinity",
              divideByZeroValue: "Infinity"
            }
          ],
          localization: "/static/webdatarocks/es.json"                     
        }    
      },       

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_display_services_customers', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_display_services_customers')) {
          this.filter = JSON.parse(Storage.getValue('filter_display_services_customers'))
        }         
      },

      goProject(item) {
        this.$router.push({ name: 'ProjectStaffDetailHoursProjects', params: { projectID: item.project_id } })                  
      }
    }    
  }
</script>
<style scoped>
  .crud-services-customers-reasons-canceled {
    cursor: pointer;
  }
  .crud-services-vto-warning {
    background: goldenrod;
    font-weight: bold;
    color: white;
  }
  .crud-services-vto-success {
    background: darkgreen;
    font-weight: bold;
    color: white;
  }  
  .crud-services-vto-danger {
    background: darkred;
    font-weight: bold;
    color: white;
  }      
  .display-service-customers-table-foot-legend {
    background: var(--gray-dark);
    color: #fff;
    font-weight: 600;
    text-align: right;
    padding-right: 10px;
    font-size: 16px;
    vertical-align: middle;
  }
  .display-service-customers-table-foot-total {
    background: var(--gray-dark);
    color: #fff;
    font-weight: 600;
    text-align: right;
    padding-right: 10px;
    font-size: 16px;
  }  
  .display-service-customers-table-foot-total-renewal {
    background: var(--gray-dark);
    color: #fff;
    font-weight: 600;
    text-align: right;
    padding-right: 10px;
    font-size: 16px;    
    font-style: italic;
  }
  .display-services-customer-legend {
    cursor: pointer;
  }
  .display-services-customer-form-renewal-period-legend {
    font-size: 14px;
  }
  .display-services-legend-renewal {
    cursor: pointer;
  }  
  .display-services-customer-table-activity {
    min-height: 100px;
    overflow: auto;
    height: 400px;    
  }  
  .popover-observations {
    cursor: pointer;
  }
  .crud-services-list-prices-public {
    font-size: 10px;
    font-weight: 600;
    color: gray;
  }  
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>
<style>
  .display-observations-ql-editor .ql-editor {
    min-height: 350px !important;
  }  
</style>